import { render, staticRenderFns } from "./birthInfo.vue?vue&type=template&id=cac0530c&scoped=true"
import script from "./birthInfo.vue?vue&type=script&lang=js"
export * from "./birthInfo.vue?vue&type=script&lang=js"
import style0 from "./birthInfo.vue?vue&type=style&index=0&id=cac0530c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac0530c",
  null
  
)

export default component.exports